import React from 'react';
import { Button, Modal } from 'antd';
import { HUMAN_REVIEW_PROVIDERS_ROUTE } from '../serviceProviderDirectory';

type DemoHumanReviewModalProps = {
  visible: boolean;
  onClose: () => void;
};

const DemoHumanReviewModal: React.FC<DemoHumanReviewModalProps> = ({ visible, onClose }) => {
  return (
    <Modal
      title={
        <div>
          <center>Need a human review of your translation?</center>
        </div>
      }
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="providers" type="primary" href={HUMAN_REVIEW_PROVIDERS_ROUTE}>
          View Human Review Providers
        </Button>,
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
      width={800}
    >
      <p>
        Some authors choose to work with an independent human reviewer before publication.
      </p>
      <p>View third-party providers familiar with AI-assisted translation workflows.</p>
    </Modal>
  );
};

export default DemoHumanReviewModal;
